const Logo = ({ size = "md", showText = true, mobileSize = null }) => {
  const sizeClasses = {
    sm: "h-8 sm:h-10",
    md: "h-10 sm:h-14",
    lg: "h-12 sm:h-16 lg:h-20",
    xl: "h-16 sm:h-20 lg:h-24"
  };
  
  // Use mobileSize for responsive or fallback to size
  const responsiveClass = mobileSize 
    ? `${sizeClasses[mobileSize]} sm:${sizeClasses[size]}`
    : sizeClasses[size];

  return (
    <div className="company-logo flex items-center gap-2">
      {/* Logo Image */}
      <img
        src="/challenge-pack-logo.png"
        alt="Challenge Pack"
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
      
      {showText && (
        <div className="hidden sm:block">
          <div className="text-emerald-400 font-black text-base sm:text-lg tracking-wider">
            Challenge Pack
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
